import { render, staticRenderFns } from "./CheckForDupsPage.vue?vue&type=template&id=2a6a0165&scoped=true"
import script from "./CheckForDupsPage.vue?vue&type=script&lang=js"
export * from "./CheckForDupsPage.vue?vue&type=script&lang=js"
import style0 from "./CheckForDupsPage.vue?vue&type=style&index=0&id=2a6a0165&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a0165",
  null
  
)

export default component.exports